/**
 * Notifications API client (Sub-pass F2).
 *
 * Two endpoints:
 *
 *   fetchUnread({ category? })   → page-targeted popups
 *   fetchUnread({ mine: true })  → user-targeted (the supervisor's app)
 *   ackNotification(id)          → dismiss + audit-stamp
 *   ackRefusal(refusal)          → a refused action's box was accepted; audit-stamp
 */

import { apiFetch } from './api';

export interface UnreadNotification {
  id: string;
  category: string;
  subject: string | null;
  body: string | null;
  metadata: unknown | null;
  createdAt: string;
}

export async function fetchUnreadNotifications(
  opts: { category?: string; mine?: boolean } = {},
  signal?: AbortSignal,
): Promise<UnreadNotification[]> {
  const data = await apiFetch<{ notifications: UnreadNotification[] }>(
    '/api/notifications/unread',
    {
      method: 'GET',
      query: {
        category: opts.category ?? null,
        mine: opts.mine ? '1' : null,
      },
      signal,
    },
  );
  return data.notifications;
}

export async function ackNotification(id: string): Promise<void> {
  await apiFetch<unknown>(`/api/notifications/${id}/ack`, { method: 'PATCH' });
}

export async function ackRefusal(refusal: {
  code: string | null;
  request: string | null;
  message: string;
  screen: string;
}): Promise<void> {
  await apiFetch<unknown>('/api/notifications/refusals/ack', { method: 'POST', body: refusal });
}
